module.exports = __webpack_public_path__ + "assets/post.4f1521cb.svg";